import { Box, DesignTokenColor, HStack, Icon, IconProps, Text, TextProps } from '@medely/ui-kit';
import React from 'react';

type DirectDepositSwitchButtonProps = {
  isCardSelected: boolean;
  onChange: (value: boolean) => void;
};

type DirectDepositItemProps = {
  mainColor: DesignTokenColor;
  bgColor: DesignTokenColor | undefined;
  onClick: () => void;
  label: TextProps['children'];
  iconName: IconProps['name'];
};

const DirectDepositItem = ({
  mainColor,
  bgColor,
  onClick,
  label,
  iconName,
}: DirectDepositItemProps) => {
  return (
    <Box
      borderColor={mainColor}
      borderWidth={1}
      borderRadius="8px"
      bgColor={bgColor}
      p={1}
      onClick={onClick}
    >
      <Icon name={iconName} color={mainColor} variant="custom" iconSize="25px" />
      <Text size="m" color={mainColor}>
        {label}
      </Text>
    </Box>
  );
};

const getItemColors = (isSelected: boolean) => ({
  mainColor: isSelected
    ? ('state.teal.primary' as DesignTokenColor)
    : ('text.secondary' as DesignTokenColor),
  bgColor: isSelected ? ('state.teal.backing' as DesignTokenColor) : undefined,
});

export const DirectDepositSwitchButton = ({
  isCardSelected,
  onChange,
}: DirectDepositSwitchButtonProps) => {
  const cardColors = getItemColors(isCardSelected);
  const bankColors = getItemColors(!isCardSelected);

  return (
    <HStack gap={2}>
      <Box width="48%">
        <DirectDepositItem
          mainColor={cardColors.mainColor}
          bgColor={cardColors.bgColor}
          onClick={() => onChange(true)}
          label="Card"
          iconName="solid-credit-card"
        />
      </Box>

      <Box width="48%">
        <DirectDepositItem
          mainColor={bankColors.mainColor}
          bgColor={bankColors.bgColor}
          onClick={() => onChange(false)}
          label="Bank"
          iconName="solid-building-columns"
        />
      </Box>
    </HStack>
  );
};
